import { InjectionToken } from '@angular/core'

export const FACTORY_TOKEN = new InjectionToken<string>('SignalR')
